import React from "react";
import { Container } from "react-bootstrap";
import { DealerContainer } from "./style";
import Button from "components/button";
import EmptyState from "components/emptyState";
import {BsCheck} from "react-icons/bs"
const UsageView = ({ setUsage, selectedUsage, usages, next, prev }) => {
  return (
    <DealerContainer>
      <Container>
        {usages.length ? (
          usages.map((usage, index) => (
            <div
              className="items"
              key={index}
              onClick={() => setUsage(usage.id)}
            >
              <div
                className={`item${
                  selectedUsage === usage.id ? " selected" : ""
                }`}
              >
                {usage.title}
                <BsCheck className="checked"/>
              </div>
            </div>
          ))
        ) : (
          <EmptyState message="کاربردی وجود ندارد" />
        )}
        <div className="buttons">
          <Button title="مرحله قبل" onClick={prev} />
          <Button
            title="تایید و ادامه"
            onClick={next}
            disabled={!selectedUsage}
          />
        </div>
      </Container>
    </DealerContainer>
  );
};
export default UsageView;
